/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_st_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The mean is the arithmetic average; the median is the middle value. The median is less affected by extreme outliers than the mean.`)
};

const es_st_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La media es el promedio aritmético; la mediana es el valor central. La mediana se ve menos afectada por valores atípicos extremos que la media.`)
};

const de_st_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Mittelwert ist der arithmetische Durchschnitt; der Median ist der mittlere Wert. Der Median wird von extremen Ausreißern weniger beeinflusst als der Mittelwert.`)
};

const nl_st_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het gemiddelde is het rekenkundig gemiddelde; de mediaan is de middelste waarde. De mediaan wordt minder beïnvloed door extreme uitschieters dan het gemiddelde.`)
};

const fr_st_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La moyenne est la moyenne arithmétique ; la médiane est la valeur centrale. La médiane est moins affectée par les valeurs extrêmes que la moyenne.`)
};

const it_st_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La media è la media aritmetica; la mediana è il valore centrale. La mediana è meno influenzata dai valori estremi rispetto alla media.`)
};

const pt_br2_st_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A média é a média aritmética; a mediana é o valor do meio. A mediana é menos afetada por valores extremos do que a média.`)
};

const pt_st_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A média é a média aritmética; a mediana é o valor central. A mediana é menos afetada por valores extremos do que a média.`)
};

const ja_st_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`平均値は算術平均、中央値は真ん中の値です。中央値は極端な外れ値の影響を平均値より受けにくい性質があります。`)
};

const zh_st_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`平均数是算术平均值；中位数是位于中间的数值。中位数受极端异常值的影响比平均数小。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const st_faq_a1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.st_faq_a1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("st_faq_a1", locale)
	if (locale === "en") return en_st_faq_a1(inputs)
	if (locale === "es") return es_st_faq_a1(inputs)
	if (locale === "de") return de_st_faq_a1(inputs)
	if (locale === "nl") return nl_st_faq_a1(inputs)
	if (locale === "fr") return fr_st_faq_a1(inputs)
	if (locale === "it") return it_st_faq_a1(inputs)
	if (locale === "pt-BR") return pt_br2_st_faq_a1(inputs)
	if (locale === "pt") return pt_st_faq_a1(inputs)
	if (locale === "ja") return ja_st_faq_a1(inputs)
	return zh_st_faq_a1(inputs)
};